import { X } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface RemoveButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel: string;
  className?: string;
}

export function RemoveButton({
  onClick,
  ariaLabel,
  className,
}: RemoveButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'group',
        'absolute -top-2 -right-2',
        'flex size-6 items-center justify-center rounded-full bg-white text-black',
        'border-2 border-seeker-900 shadow-[0_0_10px_rgba(0,0,0,0.2)]',
        'hover:bg-seeker-200 active:scale-95',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60',
        'z-10 pointer-events-auto',
        'transition-[background-color,transform] duration-150 ease-out',
        className,
      )}
      aria-label={ariaLabel}
    >
      <X className="size-3.5" strokeWidth={2.5} />
    </button>
  );
}
